import Siema from '../patches/siema-patched';

const SELECTORS = {
  container: '.js-hero-slider-container',
  carousel: '.js-hero-slider',
  button: '.js-hero-slider-button',
  arrow: '.js-hero-slider-arrow',
};

const CLASS = {
  active: 'is-active',
};

class HeroSlider {
  constructor(container) {
    this.container = container;
    this.carousel = this.container.querySelector(SELECTORS.carousel);
    this.buttons = Array.from(
      this.container.querySelectorAll(SELECTORS.button),
    );
    this.startIndex = 0;

    this.options = {
      selector: this.carousel,
      duration: 600,
      draggable: true,
      loop: true,
      startIndex: this.startIndex,
      easing: 'cubic-bezier(0.24, 0.45, 0.39, 0.95)',
      onInit: this.onSliderInit.bind(this),
      onChange: this.onSliderChange.bind(this),
    };

    this.siema = new Siema(this.options);

    this.buttonsControl();
    this.arrowsControl();
  }

  set activeButton(value) {
    /* eslint no-underscore-dangle: ["error", { "allowAfterThis": true }] */
    this._activeButton = value;
  }

  get activeButton() {
    return this._activeButton;
  }

  onSliderInit() {
    this.updateActiveButton(this.startIndex);
  }

  onSliderChange() {
    if (this.activeButton.dataset.id === String(this.siema.currentSlide))
      return;
    this.activeButton.classList.remove(CLASS.active);
    this.updateActiveButton();
  }

  updateActiveButton(index = this.siema.currentSlide) {
    this.activeButton = this.buttons.find(
      (button) => button.dataset.id === String(index),
    );
    this.activeButton.classList.add(CLASS.active);
  }

  buttonsControl() {
    this.buttons.forEach((button) => {
      button.addEventListener('click', this.buttonHandler.bind(this));
    });
  }

  arrowsControl() {
    const arrows = Array.from(this.container.querySelectorAll(SELECTORS.arrow));

    arrows.forEach((arrow) => {
      arrow.addEventListener('click', this.arrowHandler.bind(this));
    });
  }

  buttonHandler(event) {
    const index = event.target.dataset.id;
    this.siema.goTo(index);
  }

  arrowHandler(event) {
    const { direction } = event.target.dataset;
    this.siema[direction]();
  }
}

export default () => {
  Array.from(document.querySelectorAll(SELECTORS.container)).forEach(
    (container) => new HeroSlider(container),
  );
};
